import { FormField } from "../types/form";

export const formFields: FormField[] = [
    {
        name: 'category',
        label: 'طلبك للاستخدام',
        type: 'radio',
        required: true,
        options: [
            { label: 'أخرى', value: 'others' },
            { label: 'نشاط تجارى', value: 'busniess' },
            { label: 'شخصى', value: 'personal' },
            { label: 'الأسرة', value: 'family' },
            { label: 'قطع غيار السيارات', value: 'auto-spare parts' }
        ],
        gridSize: 12
    },
    {
        name: 'business_activity',
        label: 'نوع النشاط التجاري',
        type: 'select',
        required: true,
        options: [
            { label: 'بقالة', value: 'Grocery' },
            { label: 'الوجبات السريعة والمطاعم', value: 'Fast food & restaurants' },
            { label: 'فواكه وخضروات', value: 'Fruits & veggies' },
            { label: 'اللحوم والدواجن', value: 'Butchers & poultry' },
            { label: 'الصيدليات', value: 'Pharmacies' },
            { label: 'الموضة', value: 'Fashion' }
        ],
        gridSize: 12,
        conditional: (values) => values.category === 'busniess'
    },
    {
        name: 'password',
        label: 'كلمة المرور',
        type: 'password',
        required: true,
        gridSize: 6
    },
    {
        name: 'phone',
        label: 'رقم الموبيل',
        type: 'tel',
        required: true,
        gridSize: 6
    },
    {
        name: 'email',
        label: 'البريد الالكترونى',
        type: 'email',
        required: true,
        gridSize: 6
    },
    {
        name: 'name',
        label: 'الاسم الثلاثى',
        type: 'text',
        required: true,
        gridSize: 6
    },
    // {
    //     name: 'arrivalTime',
    //     label: 'الوقت لوصول الطلب',
    //     type: 'time',
    //     required: true,
    //     gridSize: 4
    // },
    // {
    //     name: 'arrivalDate',
    //     label: 'اليوم لوصول الطلب',
    //     type: 'date',
    //     required: true,
    //     gridSize: 4
    // },
    {
        name: 'street',
        label: 'اسم الشارع',
        type: 'text',
        required: true,
        gridSize: 12,
    },
    {
        name: 'apartmentNo',
        label: 'رقم الشقة',
        type: 'text',
        required: true,
        gridSize: 4
    },
    {
        name: 'floor',
        label: 'الدور',
        type: 'text',
        required: true,
        gridSize: 4
    },
    {
        name: 'buildingNo',
        label: 'رقم العقار',
        type: 'text',
        required: true,
        gridSize: 4
    },
    {
        name: 'government',
        label: 'المحافظة',
        type: 'text',
        required: true,
        gridSize: 4
    },
    {
        name: 'city',
        label: 'المدينة',
        type: 'text',
        required: true,
        gridSize: 4
    },
    {
        name: 'area',
        label: 'المنطقة',
        type: 'text',
        required: true,
        gridSize: 4
    },
    // {
    //     name: 'others',
    //     label: 'ملحوظة',
    //     type: 'textarea',
    //     required: false,
    //     gridSize: 12,
    //     multiline: true,
    //     rows: 3
    // }
];
